import React from "react";
import { UseFormClearErrors } from "react-hook-form";
import Checkbox from "app/components/common/inputs/Checkbox";

interface CustomCheckboxProps {
  setIsChecked: React.Dispatch<React.SetStateAction<boolean>>;
  clearErrors?: UseFormClearErrors<any>;
  passportImage?: string | null;
  selectedFile?: File | null;
  isChecked: boolean;
  fieldName?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const HasValidAustralianPassport: React.FC<CustomCheckboxProps> = ({
  isChecked,
  setIsChecked,
  passportImage,
  selectedFile,
  fieldName,
  clearErrors,
  onChange,
}) => {
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setIsChecked(checked);

    if (checked && fieldName && clearErrors) {
      clearErrors(fieldName);
    }

    // Call external onChange if provided
    if (onChange) {
      onChange(e);
    }
  };
  return (
    <div className="mt-6 mb-2">
      <Checkbox
        id={`terms-${fieldName}`}
        labelHtml={
          <span className="text-[#98A2B3] text-[12px]">
            I don't have a valid Australian Passport
          </span>
        }
        checked={isChecked}
        disabled={!!passportImage || !!selectedFile}
        // onChange={(e) => {
        //   const checked = e.target.checked;
        //   setIsChecked(checked);
        //   if (checked && fieldName && clearErrors) {
        //     clearErrors(fieldName);
        //   }
        // }}
        onChange={handleCheckboxChange}
        labelClassName="sm:mt-[-15px]"
      />
    </div>
  );
};

export default HasValidAustralianPassport;
